//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../no/NXObject.js";
import "../no/ScCollector.js";
let d=[[[0,"FlangeDirection",1,"Direction",0],[0,"FlangeEndProfile",0,"ScCollector",0],[0,"FlangeProfile",0,"ScCollector",0],[0,"FlangeProfileDirection",1,0],[0,"FlangeSide",1,0],[0,"FlangeType",1,0]],[[[],"DefineBases",{},0,0]],[]];
SPLM.Die.DieAssistantFlangeProfile = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.DieAssistantFlangeProfile";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.DieAssistantFlangeProfileType = Object.freeze({
    "Wipe" : "Wipe", "FormAndRestrike" : "FormAndRestrike"});

export default SPLM;